import React, { useState } from "react";
import { Box, useColorModeValue } from "@chakra-ui/react";

const JF = "'Josefin Sans', sans-serif";
const PJ = "'Plus Jakarta Sans', sans-serif";

const STYLES = `
  .nl-pill-input {
    background: transparent;
    border: none;
    outline: none;
    flex: 1;
    min-width: 0;
  }
  .nl-pill-input::placeholder {
    font-style: italic;
  }
  .nl-submit {
    background: transparent;
    border: none;
    cursor: pointer;
    transition: opacity 0.2s ease;
    white-space: nowrap;
    flex-shrink: 0;
  }
  .nl-submit:hover:not(:disabled) { opacity: 0.5; }
  .nl-submit:disabled { cursor: not-allowed; opacity: 0.4; }
`;

export default function Newsletter() {
  const [email, setEmail]     = useState("");
  const [status, setStatus]   = useState("idle");
  const [message, setMessage] = useState("");

  const pillBg      = useColorModeValue("#e2e2e0", "#2a2a2a");
  const inputColor  = useColorModeValue("#222222", "#aaaaaa");
  const placeholderColor = useColorModeValue("#888888", "#666666");
  const submitColor = useColorModeValue("#555555", "#888888");
  const successColor= useColorModeValue("#2a7a2a", "#66cc66");
  const errorColor  = useColorModeValue("#cc3333", "#ff6b6b");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setStatus("loading");
    setMessage("");
    try {
      const res  = await fetch("/.netlify/functions/subscribe", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();
      if (res.ok) {
        setStatus("success");
        setEmail("");
        setMessage("You're in. Check your inbox.");
      } else {
        setStatus("error");
        setMessage(data.error || "Something went wrong. Please try again.");
      }
    } catch {
      setStatus("error");
      setMessage("Network error. Please try again.");
    }
  };

  return (
    <Box w="100%">
      <style>{STYLES}</style>

      {status === "success" ? (
        <Box
          fontFamily={JF}
          fontSize="11px"
          letterSpacing="0.16em"
          textTransform="uppercase"
          color={successColor}
          textAlign="center"
          py={3}
        >
          ✓ &nbsp;You're in. Check your inbox.
        </Box>
      ) : (
        <Box as="form" onSubmit={handleSubmit}>
          <Box
            display="flex"
            alignItems="center"
            bg={pillBg}
            borderRadius="100px"
            px={5}
            py={3}
            maxW="400px"
            mx="auto"
          >
            <Box
              as="input"
              className="nl-pill-input"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="Email Newsletter"
              type="email"
              required
              fontFamily={PJ}
              fontSize="14px"
              color={inputColor}
              sx={{ "::placeholder": { color: placeholderColor } }}
            />
            <Box
              as="button"
              type="submit"
              className="nl-submit"
              disabled={status === "loading"}
              fontFamily={JF}
              fontSize="11px"
              fontWeight="700"
              letterSpacing="0.16em"
              textTransform="uppercase"
              color={submitColor}
            >
              {status === "loading" ? "..." : "Submit"}
            </Box>
          </Box>

          {status === "error" && (
            <Box fontFamily={PJ} fontSize="12px" color={errorColor} mt={2} textAlign="center">
              {message}
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
}
